import {apiClient} from "./apiClient.ts";

export async function postOcrVin(payload) {
    const {data} = await apiClient.post("/ocr/vin", payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
    return data.data
}